import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';

import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';

import rootReducer from './modules';

export const history = createHistory();
const middleware = routerMiddleware(history);

const enhancers = [
  applyMiddleware(thunkMiddleware),
  applyMiddleware(middleware)
];


// Enable redux dev tools only in development
const composeEnhancers = (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export const configureStore = (initialState = {}) => {
  // const enhancer = composeEnhancers(...enhancers, applyMiddleware(routerMiddleware(history)));
  const enhancer = composeEnhancers(...enhancers);
  const store = createStore(rootReducer, initialState, enhancer);
  return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.js